import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillMail,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Footer() {
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = (e) => {
    e.preventDefault();
    navigator.clipboard.writeText("taruntalan12@gmail.com").then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <Container fluid className="footer">
      <Row className="align-items-center">
        <Col md="6" className="footer-copywright">
          <h3>Designed & Developed by Tarun Talan</h3>
        </Col>
        <Col md="6" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://github.com/TarunTalan"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillGithub />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://twitter.com/taruntalan01"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiOutlineTwitter />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/tarun-talan-77360a37a/"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <FaLinkedinIn />
              </a>
            </li>
            <li className="social-icons" style={{ position: "relative" }}>
              <a
                href="mailto:taruntalan12@gmail.com"
                onClick={handleCopyEmail}
                style={{ color: "white" }}
                title="Copy email to clipboard"
              >
                <AiFillMail />
              </a>
              {copied && (
                <span
                  style={{
                    position: "absolute",
                    top: "-40px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: "#c770f0",
                    color: "white",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    fontSize: "12px",
                    whiteSpace: "nowrap",
                    boxShadow: "0 0 10px rgba(199, 112, 240, 0.5)",
                    zIndex: 10,
                  }}
                >
                  Copied!
                </span>
              )}
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
